import styled from "styled-components"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { Quote1, Quote2 } from "./AllImages"
export const Box = styled.div`
    background-color: ${({ bg }) => bg ? bg : ''};
`
export const IconBoxColor = styled.div`
    svg {
        [stroke] {
            stroke: ${({ iconColor }) => iconColor ? iconColor : ''};
        }
    }
`
export const LazyImage = (props) => {
    return (
        <LazyLoadImage
            {...props}
            effect="blur"
        />
    )
}
export const HeadingStyled = styled.div`
    font-size:${props => props.size ? props.size : '20px'};
    font-weight:${props => props.weight ? props.weight : 'var(--medBold)'};
    font-family: ${props => props.family ? props.family : "var(--familyRbtFlex)"};
    color:${props => props.color ? props.color : ""};
    line-height: ${props => props.lh ? props.lh : '1'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    display: ${props => props.display ? props.display : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    body.rtl &{
        font-size: 22px;
        font-family: ${props => props.family ? props.family : "var(--arBold)"};
        font-weight: var(--bold);
    }
`
export const SpanStyled = styled.span`
    display: inline-block;
    font-size:${props => props.size ? props.size : '18px'};
    font-weight:${props => props.weight ? props.weight : 'var(--regular)'};
    font-family: ${props => props.family ? props.family : "var(--familyRbt)"};
    color:${props => props.color ? props.color : "var(--themeColor)"};
    line-height: ${props => props.lh ? props.lh : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arRegular)"};
        font-size: 20px;
    }
`
export const SpanStyledB = styled.span`
    font-size:${props => props.size ? props.size : '20px'};
    font-weight:${props => props.weight ? props.weight : ''};
    font-family: ${props => props.family ? props.family : "var(--familyRbtFlex)"};
    color:${props => props.color ? props.color : "var(--text2)"};
    line-height: ${props => props.lh ? props.lh : ''};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    position: relative;
    margin-top: 30px;
    &::before, &::after{
        content: '';
        width: 57px;
        height: 53px;
        position: absolute;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
    }
    &::before{
        left: -80px;
        top: 9px;
        background-image: url(${Quote1});
    }
    &::after{
        right: -20px;
        top: 135px;
        background-image: url(${Quote2});
    }

    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arRegular)"};
        font-weight:${props => props.weight ? props.weight : 'var(--regular)'};
        &::before{
            left: -20px;
            top: auto;
            bottom: -50px;
        }
        &::after{
            right: -80px;
            top: 9px;
        }
    }
    @media (max-width: 991px) {
        &::before{
            width: 25px;
            height: 25px;
            left: -12px;
            top: -23px;
        }
        &::after{
            width: 25px;
            height: 25px;
            right: -7px;
            top: auto;
            bottom: -20px;
        }
        body.rtl &{
            &::before{
                left: 20px;
                top: auto;
                bottom: -30px;
            }
            &::after{
                right: -7px;
                bottom: auto;
                top: -21px;
            }
        }

    }
    
`
export const MainHeading = styled.div`
    display: block;
    font-size:${props => props.size ? props.size : '48px'};
    font-family: ${props => props.family ? props.family : "var(--familyRbt)"};
    color:${props => props.color ? props.color : "var(--themeColor)"};
    line-height: ${props => props.lh ? props.lh : '1.3'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    font-weight: ${props => props.weight ? props.weight : "var(--extraBold)"};
    /* -webkit-text-stroke: 2px black; */
    body.rtl &{
        font-family: var(--arBold);
        font-size: 40px;
        font-weight: 600;
        
    }
    @media (max-width: 575px) {
        font-size: 32px;
        &.main-heading-sub{
            font-size: 25px;
        }
        body.rtl &{
            font-size: 32px;
        }
    }
`
export const InnerHeading = styled.div`
    font-size:${props => props.size ? props.size : '56px'};
    font-family: ${props => props.family ? props.family : "var(--familyRbtFlex)"};
    color:${props => props.color ? props.color : "var(--secondaryColor)"};
    line-height: ${props => props.lh ? props.lh : '1'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    font-weight:${props => props.weight ? props.weight : 'var(--medium)'};
    /* -webkit-text-stroke: 2px black; */
    body.rtl &{
        font-size:${props => props.size ? props.size : '56px'};
        font-family: ${props => props.family ? props.family : "var(--arMedium)"};
    }
    @media (max-width: 991px) {
        font-size: 35px;
        body.rtl &{
            font-size: 35px;
        }
    }
`
export const TextStyledSem = styled.div`
    font-size:${props => props.size ? props.size : '20px'};
    font-family: ${props => props.family ? props.family : "var(--semiBold)"};
    color:${props => props.color ? props.color : "var(--white)"};
    line-height: ${props => props.lh ? props.lh : '1'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    text-transform: ${props => props.transform ? props.transform : ''};
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arSemiBold)"};
    }
`
export const TextStyled = styled.p`
    font-size:${props => props.size ? props.size : '18px'};
    font-weight:${props => props.weight ? props.weight : 'regular'};
    font-family: ${props => props.family ? props.family : "var(--familyRbt)"};
    color:${props => props.color ? props.color : "var(--themeColor)"};
    line-height: ${props => props.lh ? props.lh : '1.4'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    body.rtl &{
        font-size: 20px;
        font-family: ${props => props.family ? props.family : "var(--arRegular)"};
    }
`
export const LabelStyled = styled.label`
    font-size:${props => props.size ? props.size : '16px'};
    font-family: ${props => props.family ? props.family : "var(--medium)"};
    color:${props => props.color ? props.color : 'var(--text2)'};
    line-height:${props => props.lh ? props.lh : 'normal'};
    letter-spacing: ${props => props.spacing ? props.spacing : ''};
    margin-bottom: 2px;
    body.rtl &{
        font-family: ${props => props.family ? props.family : "var(--arRegular)"};
    }
`
export const ButtonStyled = styled.button`
    font-size:${props => props.size ? props.size : '16px'};
    font-weight:${props => props.weight ? props.weight : '500'};
    font-family:${props => props.direction === 'ltr' && props.family ? props.family : "var(--medium)"};
    background-color:${props => props.bg ? props.bg : "none"};
    color: ${props => props.color ? props.color : "var(--ThemeColor)"};
    padding: ${props => props.padding ? props.padding : "11px 20px"};
    border: ${props => props.border ? props.border : "none"};
    width: ${props => props.width ? props.width : "100%"};
    line-height: ${props => props.lineHeight ? props.lineHeight : "normal"};
    border-radius: ${props => props.radius ? props.radius : "8px"};
    transition: 0.3s ease-in-out opacity;
    letter-spacing: 0.8px;
    &:hover {
        opacity: 0.8;
    }
`
export const CardStyled = styled.div`
    box-shadow: 0px 5px 4px rgba(0, 0, 0, 0.03);
    border-radius: 15px;
    background-color:${props => props.bg ? props.bg : "var(--white)"};
    .card-styled-header {
        padding: 16px;
        border-bottom: 1px solid var(--grey-light);
        margin-bottom: 16px;
    }
`